import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  constructor(private http: HttpClient) { }
  public profilePic$ = new BehaviorSubject<boolean>(false);
  public userDetails:any;
  public iamVideo$ = new BehaviorSubject<boolean>(true);
  public userProfileDetails:any;
  registerUser(obj: any): Observable<any> {
    const url = environment.apiURL + `api/user`
    return this.http.post(url, obj, { observe: 'response' });
  }

  loginUser(obj: any): Observable<any> {
    const url = environment.apiURL + `api/login`
    let headers = new HttpHeaders();
    headers = headers.set('content-type', 'application/x-www-form-urlencoded');
    let body = new URLSearchParams();
    body.set('emailAddress', obj.emailAddress);
    body.set('password', obj.password);
    body.set('remember-me', 'true');
    return this.http.request('post', url, { body: body.toString(), headers });
  }

  userLoginV2(obj: any): Observable<any> {
    const url = environment.apiURL + `api/v2/login`;
    return this.http.post(url, obj)
  }

  resetPassword(obj: any) {
    const url = environment.apiURL + `api/user/password/verify-code`;
    return this.http.post(url, obj)
  }

  verifyEmail(obj: any) {
    const url = environment.apiURL + `api/user/password/verify-email`;
    return this.http.post(url, obj, { observe: 'response' })
  }

  ssoSignIn(obj: any): Observable<any> {
    const url = environment.apiURL + `api/v3/login/firebase`
    let headers = new HttpHeaders();
    headers = headers.set('X-Authorization-Firebase', obj);
    return this.http.get(url, {
      headers: headers
    })
  }

  verifyUserSignUp(userId, verificationCode): Observable<any> {
    const url = environment.apiURL + `api/user/${userId}/verify-code`;
    return this.http.post(url, verificationCode, { observe: 'response' })
  }

  resendEmail(userId): Observable<any> {
    const url = environment.apiURL + `api/user/${userId}/resend-code`;
    return this.http.post(url, null)
  }

  updateUserPassword(obj): Observable<any> {
    const url = environment.apiURL + `api/user/password/update`;
    return this.http.post(url, obj, { observe: 'response' })
  }

  postSetup1(id: any, text: any, file: any): Observable<any> {
    const url = environment.apiURL + `api/account/${id}/setup/1`;
    const formData = new FormData();
    formData.append('myWords', text);
    formData.append('picture', file);
    return this.http.post(url, formData);
  }

  postSetup2(id: any, text: any): Observable<any> {
    const url = environment.apiURL + `api/account/${id}/setup/2`;
    return this.http.post(url, text);
  }

  postSetup3(file: any, id: any, data: any): Observable<any> {
    const url = data.updatedTreasuryId ? environment.apiURL + `api/account/${id}/setup/3?updatedTreasuryId=${data.updatedTreasuryId}` : environment.apiURL + `api/account/${id}/setup/3`;
    const formData = new FormData();
    formData.append('image', file);
    const params = new HttpParams().set('treasuryName', data.treasuryName).set('treasuryTitle',
      data.treasuryTitle).set('treasuryDesc', data.treasuryDesc)
      .set('expThisLink', data.expThisLink).set('userId', id);
    return this.http.post(url, formData, { params });
  }

  postSetup4(data: any, id: any): Observable<any> {
    const url = environment.apiURL + `api/account/${id}/setup/4`;
    const formData = new FormData();
    formData.append('isIamVideoTool', 'false');
    formData.append('vid', data);
    formData.append('update', 'true');
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*'
    });
    return this.http.post(url, formData, { headers });
  }


  getShowcases(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/showcases`;
    return this.http.get(url);
  }

  getUserProfile(userId): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}`
    return this.http.get(url);
  }

  logoutUser(params?: any): Observable<any> {
    const url = environment.apiURL + `api/v2/logout`
    return this.http.get(url, params);
  }

  resendEmailVerficationCode(userId, params?: any): Observable<any> {
    const url = environment.apiURL + `api/user/${userId}/resend-code`;
    return this.http.post(url, params);
  }

  uploadProfile(userId: any, params?: any): Observable<any> {
    const url = environment.apiURL + `api/user-profile/${userId}/profilePic`;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*'
    });
    return this.http.post(url, params, { headers });
  }

  uploadBackgroundPic(params?: any): Observable<any> {
    const url = environment.apiURL + `api/user-profile/userId/account/updateBackgroundImage`;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Accept': '*/*'
    });
    return this.http.post(url, params, { headers });
  }

  deleteTresurey(id: any, userId: any, params?: any): Observable<any> {
    const url = environment.apiURL + `api/v2/treasuryDelete/${id}/user/${userId}`
    return this.http.post(url, params);
  }

  hideTresurey(id: any, userId: any, params?: any): Observable<any> {
    const url = environment.apiURL + `api/v2/treasuryToggleView/${id}/user/${userId}`;
    return this.http.post(url, params);
  }

  verifyEmailOnURLToken(token: any): Observable<any> {
    const url = environment.apiURL + `api/v2/verifyEmailToken/${token}`
    return this.http.get(url)
  }

  verifyTokenSetupPassword(token: any): Observable<any> {
    //https://www.creatics.org/api/verifyforgotpassword/
    const url = environment.apiURL + `api/v2/emailVerifyForgotPassword/${token}`
    return this.http.get(url)
  }

  resendForgotPassword(id:any, params?:any):Observable<any>{
    const url = environment.apiURL + `api/user/${id}/resend-code-forgot-password`;
    return this.http.post(url, params)
  }

  postSetupVisited(id, params?: any): Observable<any> {
    const url = environment.apiURL + `api/account/${id}/setup/visited`;
    return this.http.post(url, params);
  }

  postUpvote(obj:any):Observable<any>{
    const url = environment.apiURL + `api/upvoteTreasury`;
    return this.http.post(url, obj);
  }

  getTresureyVotingByTresureyId(id:any):Observable<any>{
    const url = environment.apiURL + `api/getTreasuryVoting?treasuryId=${id}`;
    return this.http.get(url,{ responseType: 'text'});
  }

  getCreaticsCurrency():Observable<any>{
    const url = environment.apiURL + `api/totalCreaticsCurrency`;
    return this.http.get(url,{ responseType: 'text'});
  }

  getUpvoteDetailsForIAMVideo(videoId:any):Observable<any>{
    const url = environment.apiURL + `api/getrating?videoCreatorId=${videoId}`;
    return this.http.get(url,{ responseType: 'text'});
  }

  postUpvoteForIAMVideo(obj:any):Observable<any>{
    const url = environment.apiURL + `api/upvoteitem`;
    return this.http.post(url,obj,{ responseType: 'text'});
  }

  getUpvoteBalance():Observable<any>{
    const url = environment.apiURL + `api/userUpvoteBalance`;
    return this.http.get(url,{ responseType: 'text'});
  }
}
